'use strict';

var analytics = require('../analytics');
var throttle = require('lodash.throttle');
var reviewScore = require('../review/reviewScore');
var io = require('socket.io-client');
var qs = require('querystring');
var checkEmptyModuleSection = require('../review/checkEmptyModules');
var calculTopBars = require('../review/dashboard/dashboardProgressStatus');
var checkEmptyModules = require('../review/checkEmptyModules');
var renderCharts = require('../charts/chartsRender');
var initGoogleCharts = require('../review/googleCharts');
var loadMustachesFiles = require('../review/loadMustachesFiles');
var competizeAll = require('../review/competitors/competizeAll');
var scrollToElement = require('../helpers/scrollToElement');
var { initLazyImages } = require('../helpers/lazyImages');

var intialized = false;
var critMap = {};

function aggregateCompetitors (report, rawCrit) {
  var crit;
  var hasParts = false;
  var isComplete;
  var isMain;
  var id = rawCrit.criterium.id;
  var hasComps = rawCrit.criterium.competitors;
  var baseUrl = rawCrit.url.split('/')[0];
  var nrOfComps = report.competitors.length;
  const nrResolved = [];

  if (rawCrit.rendered) {
    hasParts = (rawCrit.rendered.parts || []).length > 0;
  }

  if (!critMap[id]) {
    critMap[id] = {};
    nrResolved[id] = 0;
  }

  crit = critMap[id];
  isMain = rawCrit.url === report.url;

  if (hasParts || isMain) {
    crit[baseUrl] = {
      criterium: id,
      mustache: rawCrit.rendered,
      url: rawCrit.url
    };
  }

  nrResolved[id] += 1;
  isComplete = !hasComps || nrResolved[id] >= nrOfComps + 1;

  if (isComplete) {
    delete critMap[id];
    return crit;
  } else {
    return null;
  }
}

function renderParts (mustache) {
  if (Array.isArray(mustache.parts)) {
    mustache.parts = mustache.parts
      .map(function (part) {
        if (!part.data || !part.template) {
          return part;
        }

        if (part.templateId === 'tabbed') {
          part.data.tabs.forEach(function (tab) {
            tab.parts = Array.isArray(tab.parts) ? tab.parts : [tab.parts];
            renderParts(tab);
          });
        }

        return {
          rawHtml: window.Mustache.render(part.template, part.data)
        };
      })
      .filter(function (part) {
        return part;
      });
  }

  var clist = mustache.competitors && mustache.competitors.clist;
  if (Array.isArray(clist)) {
    clist.forEach(renderParts);
  }
}

function insertInHtml ($element, json, templates) {
  var mustache = json.mustache;
  if (!mustache) {
    return;
  }

  var objectId = $element.attr('id');
  var hidden = $element.hasClass('hidden');

  if (mustache.parts && !Array.isArray(mustache.parts)) {
    console.warn('Expected a parts array in %s', objectId);
    mustache.parts = null;
  }

  var isEmpty = !mustache.parts || mustache.parts.length === 0;

  renderParts(mustache);

  var htmlContent = window.Mustache.render(templates.main, mustache);
  var $htmlContent = $(htmlContent);
  $element.replaceWith($htmlContent);
  $element = $htmlContent;

  $element.toggleClass('hidden', hidden || isEmpty);

  competizeAll();

  $('#' + objectId + ' .simple-tooltip').tooltip({
    delay: {
      show: 400,
      hide: 100
    }
  });

  if (isEmpty) {
    return;
  }

  $element.formatTime();
  $element.externalLinks();
  $element.truncate();

  var event = document.createEvent('Event');
  event.initEvent('crit-html-changed', true, true);
  window.dispatchEvent(event);

  if (objectId === 'criterium-local_directories') {
    return $('.goto-local-reviews').on('click', function (event) {
      event.preventDefault();
      return scrollToElement($('#criterium-local_online_reviews'));
    });
  }
}

function receiveCriterium ({ url, competitors }, crit) {
  var currentWebsiteShort = url.split('/')[0];
  var currentWebsiteData = crit && crit[currentWebsiteShort];

  if (!currentWebsiteData || !currentWebsiteData.mustache) {
    return;
  }

  var compData = [];
  if (Object.keys(crit).length > 1) {
    for (var j = 0; j < competitors.length; j++) {
      const competitorUrl = competitors[j];
      if ((crit[competitorUrl] != null) && (crit[competitorUrl].mustache != null)) {
        compData.push(crit[competitorUrl].mustache);
      }
    }
  }

  if (compData.length > 0) {
    currentWebsiteData.mustache.competitors = {
      clist: compData
    };
  }

  var { criterium } = currentWebsiteData;
  var $element = $(`#criterium-${criterium}`);

  return loadMustachesFiles().then(function (templates) {
    return insertInHtml($element, currentWebsiteData, templates);
  });
}

function receiveCriteria (report, crits) {
  return Promise.all(crits.map(function (crit) {
    return receiveCriterium(report, crit);
  }))
    .then(function () {
      calculTopBars();
      checkEmptyModules();
      renderCharts();
      initGoogleCharts();
      initLazyImages();
      $('.criterium [data-toggle="tooltip"]').tooltip();
    });
}

function updateCrits (report, toUpdate) {
  const crits = toUpdate.map(function (rawCrit) {
    return aggregateCompetitors(report, rawCrit);
  });
  return receiveCriteria(report, crits);
}

function generateAllCrits (generationContext) {
  var url = generationContext.url;
  setTimeout(function () {
    $('.criterium.criterium-loading')
      .addClass('hidden')
      .removeClass('criterium-loading');

    checkEmptyModuleSection();

    var event = document.createEvent('Event');
    event.initEvent('crit-html-changed', true, true);
    window.dispatchEvent(event);
  }, 90000);

  var lang = window.wooGlobal.language;
  var userId = (window.wooGlobal.user && window.wooGlobal.user.id) || 0;

  return $.post(`/${lang}/report/generations`, { userId, url }, data => null);
}

function generationComplete (generationContext, data) {
  const leftoverCrits = Object.keys(critMap).map(function (key) {
    return critMap[key];
  });
  return receiveCriteria(generationContext, leftoverCrits)
    .then(function () {
      var $dashboard = $('#dashboard');
      $dashboard.removeClass('generating-report');
      $dashboard.find('#dashboard-footer a.disabled').removeClass('disabled');
      $dashboard.find('#dashboard-footer a.busy').removeClass('busy');

      $dashboard.find('#dashboard-screenshot')
        .prepend(
          `<img
            src="${data.screenshot}"
            alt="Screenshot for ${generationContext.url}"
            onerror="this.style.display='none';"
          />`)
        .find('.js-loader').remove();

      $dashboard.trigger('generationComplete');
    });
}

function initReportGeneration (generationContext) {
  analytics.event('start_generation', { url: generationContext.url });
  var start = Date.now();

  var lang = window.wooGlobal.language;
  var userId = window.wooGlobal.user && window.wooGlobal.user.id;
  var url = generationContext.url;
  var competitors = generationContext.competitors;

  var connectParams = {
    language: lang,
    userId: userId,
    url: url,
    competitors: competitors.join('|')
  };

  var socket = io(window.socketSUrl, { query: qs.stringify(connectParams) });

  var buffer = [];

  function updateBuffer () {
    const toUpdate = buffer;
    buffer = [];
    return updateCrits({ url, competitors }, toUpdate);
  }

  var updateBufferThrottled = throttle(updateBuffer, 1000);

  socket.on('data', function (data) {
    buffer = buffer.concat(data);
    updateBufferThrottled();
  });

  socket.on('score-update', function (data) {
    if (data.url === url) {
      reviewScore.finalize(data.newScore);
    } else {
      var score = Math.round(data.newScore * 10) / 10;
      if (data.newScore > 0) {
        $('#dashboard-competitors li[title="' + data.url + '"] .score')
          .text(score);
      }
    }
  });

  var endEvents = {};

  socket.on('pdf-available', function (data) {
    endEvents[data.url] = data;
    var allgenerationsDone = [url].concat(competitors).every(url => endEvents[url]);
    if (allgenerationsDone) {
      updateBufferThrottled.flush().then(function () {
        generationComplete(generationContext, endEvents[url]);
        socket.disconnect();
        analytics.event('end_generation', {
          url: generationContext.url,
          duration: Date.now() - start
        });
      });
    }
  });

  socket.on('initialized', function () {
    if (!intialized) {
      intialized = true;
      generateAllCrits(generationContext);
    }
  });
}

module.exports = initReportGeneration;
